module.exports = __webpack_public_path__ + "media/images/global/icons/accessory-51e4d1174890d19502f3d9636e1546b5.svg";